import { MockPolicyId } from "../mockPolicies";
import { testDriveMember } from "../mockMembers";
import { getMockPolicies } from "../builders/getMockPolicies";
import { insuranceAutoPayUpcoming, insuranceBillWithRevalOffer } from "../builders/createInsuranceBill";
import { cigAutoPayBill, cigRevalBill } from "../builders/createCigBill";

import { MockPersona } from "./mockPersonas.types";

const canadaPolicies: MockPolicyId[] = ["RG263345-01", "CD829471-01"];

export const squirrelyDan: MockPersona = {
  key: "squirrelyDan",
  name: "Squirrely Dan",
  description:
    "🇨🇦 | Two core policies | No HDC | One Upcoming Insurance Bill (autopay) + One Reval + One Esign | Failed Streaming",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [
          cigAutoPayBill({ id: "1", productNumber: canadaPolicies[0] }),
          cigRevalBill({ id: "2", productNumber: canadaPolicies[1] }),
        ],
      },
      policies: {
        usa: [],
        canada: getMockPolicies(...canadaPolicies),
      },
    },
    esign: {
      fetchESignDocuments: [{ Id: 1, StateRegion: "AB" }],
      createESignRequest: "success",
    },
    insurance: {
      fetchEndorsement: [],
      stream: "error",
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "dan@squirrely.com",
            firstName: "Dan",
            middleName: "",
            lastName: "Squirrely",
            mailingAddress: {
              line1: "339 Queen Street West",
              line2: "",
              city: "Letterkenny",
              state: "ON",
              postalCode: "M5V 2A4",
              country: "CANADA",
            },
            preferredPhone: "4378122784",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000026",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [
            insuranceAutoPayUpcoming({ id: "1", policyNumber: canadaPolicies[0] }),
            insuranceBillWithRevalOffer({ id: "2", policyNumber: canadaPolicies[1] }),
          ],
          outstandingBalance: 100,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
